/*
Interface to decide which environment the code is running in
*/

class EnvDecisionInterface {
    /*
        @return (string) "local", "dev", or "prod"
    */
    get = () => {
        throw new Error("get method not implemented");
    }
}

export default EnvDecisionInterface;